import { useEffect, useLayoutEffect, useState } from "react";
function getRect(element, scrollX = 0, scrollY = 0) {
    if (element) return element.getBoundingClientRect();
    return {
        bottom: 0,
        height: 0,
        left: 0 + scrollX,
        right: 0,
        top: 0 + scrollY,
        width: 0
    };
}
const useIsomorphicLayoutEffect = "u" < typeof window ? useEffect : useLayoutEffect;
function useRect(ref, update) {
    const [rect, setRect] = useState(getRect());
    useIsomorphicLayoutEffect(()=>{
        const handleScroll = ()=>{
            if (update && ref && ref.current) {
                const { left, top, width, height, bottom, right } = ref.current.getBoundingClientRect();
                const scrollX = window.scrollX || document.documentElement.scrollLeft;
                const scrollY = window.scrollY || document.documentElement.scrollTop;
                setRect({
                    left: left + scrollX,
                    top: top + scrollY,
                    width,
                    height,
                    bottom,
                    right
                });
            }
        };
        handleScroll();
        window.addEventListener('scroll', handleScroll, true);
        return ()=>{
            window.removeEventListener('scroll', handleScroll, true);
        };
    }, [
        ref,
        update
    ]);
    return rect;
}
export default useRect;
